import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';

const LiveClock = ({ isDarkMode }) => {
    const [time, setTime] = useState(dayjs());

    useEffect(() => {
        const timer = setInterval(() => setTime(dayjs()), 1000);
        return () => clearInterval(timer);
    }, []);

    return (
        <div style={{ textAlign: 'right', lineHeight: '1.2', borderLeft: isDarkMode ? '1px solid #303030' : '1px solid #f0f0f0', paddingLeft: '16px', marginLeft: '8px' }}>
            <div style={{ fontSize: '12px', fontWeight: '600', color: '#1890ff', opacity: 0.8 }}>
                {time.format('ddd, DD MMM YYYY')}
            </div>
            <div style={{ fontSize: '16px', fontWeight: '700', fontFamily: 'monospace', letterSpacing: '0.5px', color: isDarkMode ? '#fff' : '#1f1f1f' }}>
                {time.format('HH:mm:ss')}
            </div>
        </div>
    );
};

export default LiveClock;
